import React from "react";
import { Modal, Button } from "react-bootstrap";
import ChangeCreditCardForm from "../forms/ChangeCreditCardForm";
import ModalBase from '../../../../ui/modals/ModalBase';

class ChangeCreditCardModal extends ModalBase {

    renderBody = () => {
        return (
            <ChangeCreditCardForm
                onSubmit={this.onSubmitHandler}
            >
                <Button variant="secondary" block size="xl" className="lg" onClick={() => this.props.onHide()}>Cancel</Button>
            </ChangeCreditCardForm>
        )
    };

    renderHeader = () => {
        const { headerTitle, headerSubtitle } = this.props;

        return (
            <React.Fragment>
                <Modal.Title className="title">{headerTitle}</Modal.Title>
                <Modal.Title className="subtitle">{headerSubtitle}</Modal.Title>
            </React.Fragment>
        );
    };

    renderFooter = () => {
    };

    onSubmitHandler = (values) => {
        this.props.onSubmit(values);
    }

    modalClassname = () => "change-credit-card-modal";

    static defaultProps = {
        ...super.defaultProps,
        headerTitle: 'Change Card',
        headerSubtitle: 'Enter your new credit card details'
    };
}

export default ChangeCreditCardModal;
